import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconShieldOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="m12 1.75 8.01 2.577v10.286c0 2.874-4.7 6.28-8.01 7.624-3.31-1.344-8.01-4.75-8.01-7.624V4.323L12 1.747M12 0 2.334 3.133V14.61C2.334 18.783 8.5 22.783 12 24c3.5-1.217 9.667-5.217 9.667-9.39V3.133L12 .003z" /></svg>
);
